/**
 * Profanity Filter Utility
 * Detects and blocks English, Tagalog, and Bisaya profanity in messages
 */

// English profanity list (common curses and vulgar terms)
const ENGLISH_PROFANITY = [
  'fuck', 'shit', 'damn', 'ass', 'bitch', 'bastard', 'crap', 'hell',
  'dick', 'piss', 'cock', 'pussy', 'whore', 'slut', 'cunt', 'fag',
  'nigger', 'nigga', 'retard', 'idiot', 'stupid', 'moron', 'douche',
  'arse', 'wanker', 'twat', 'bloody', 'screw', 'suck', 'blowjob',
  'bullshit', 'bullsh*t', 'asshole', 'assh*le', 'dumbass', 'dumb*ss',
  'jackass', 'jack*ss', 'dickhead', 'dickh*ad', 'shithead', 'shith*ad',
  'motherfucker', 'motherf*cker', 'sonofabitch', 'sonofab*tch',
  'goddamn', 'godd*mn', 'goddammit', 'godd*mm*t',
  'fucking', 'f*cking', 'fucked', 'f*cked', 'fucker', 'f*cker',
  'shitting', 'sh*tting', 'shitted', 'sh*tted', 'shitter', 'sh*tter',
  'asshole', 'assh*le', 'arsehole', 'arsh*le',
  'dumbass', 'dumb*ss', 'dumbfuck', 'dumbf*ck',
  'jackass', 'jack*ss', 'jackoff', 'jack*ff',
  'cock', 'c0ck', 'dick', 'd1ck', 'pussy', 'pu$$y',
  'cunt', 'c*nt', 'twat', 'tw*t', 'wanker', 'w*nker',
  'bastard', 'b*stard', 'bitch', 'b*tch', 'whore', 'wh*re',
  'slut', 'sl*t', 'fag', 'f*g', 'retard', 'r*tard',
  'piss', 'p1ss', 'crap', 'cr*p', 'screw', 'scr*w',
  'damn', 'd*mn', 'hell', 'h3ll', 'ass', '*ss', 'ars3',
  'shit', 'sh1t', 'sh*t', 'fuck', 'f*ck', 'fuk', 'fukc',
  'bitch', 'b1tch', 'b*tch', 'biatch', 'bi*tch',
  'ass', 'a$$', 'a55', 'ars3', 'ar$e',
  'dick', 'd1ck', 'd*ck', 'dic', 'dik',
  'cock', 'c0ck', 'c*ck', 'coc', 'cok',
  'pussy', 'pu$$y', 'pu55y', 'p*ssy', 'pusy',
  'cunt', 'c*nt', 'cun', 'kun',
  'whore', 'wh*re', 'hore', 'hor',
  'slut', 'sl*t', 's1ut', 'slvt',
  'bastard', 'b*stard', 'basterd', 'b*sterd',
  'damn', 'd*mn', 'dam', 'd*m',
  'hell', 'h3ll', 'he11', 'h*ll',
  'crap', 'cr*p', 'krap', 'kr*p',
  'piss', 'p1ss', 'p*ss', 'pis',
  'screw', 'scr*w', 'skrew', 'skr*w',
  'suck', 's*ck', 'suk', 's*k',
  'blowjob', 'bl*wj*b', 'blowj*b', 'bl*wjob',
  'wanker', 'w*nker', 'wank', 'w*nk',
  'twat', 'tw*t', 'tw*t', 'twa',
  'douche', 'd*uche', 'douch', 'd*ch',
  'idiot', '1diot', '1d1ot', 'id1ot',
  'stupid', 'st*pid', 'stup1d', 'st*p1d',
  'moron', 'm*ron', 'mor0n', 'm*r0n',
  'retard', 'r*tard', 'ret*rd', 'r3tard',
  'nigger', 'n1gger', 'n*gger', 'nigg3r',
  'nigga', 'n1gga', 'n*gga', 'nigg4',
];

// Tagalog profanity list (common curses and vulgar terms)
const TAGALOG_PROFANITY = [
  'puta', 'putang', 'putangina', 'putanginamo', 'putanginang',
  'tangina', 'tanginamo', 'tanginang', 'tanginae',
  'gago', 'gaga', 'gag0', 'g@g0', 'gagu',
  'pota', 'potang', 'potangina', 'potanginamo',
  'tanga', 'tangang', 'tangae', 't4nga',
  'buang', 'bwang', 'bvuang', 'bu4ng',
  'kupal', 'kup4l', 'kupal', 'k*p4l',
  'tite', 'titi', 't1te', 't*t1', 'tit3',
  'puki', 'puk1', 'p*k1', 'puking',
  'lintik', 'l1ntik', 'l*ntik', 'lint1k',
  'yawa', 'yaw4', 'y*w4', 'yawa',
  'pakshet', 'paksh*t', 'paksh3t', 'paksheet',
  'leche', 'l3che', 'l*che', 'lech3',
  'punyeta', 'puny3ta', 'puny*t4', 'punyet4',
  'hinayupak', 'hin4yupak', 'hinayup4k', 'hin4yup4k',
  'ulol', 'ul0l', 'u1ol', 'u101',
  'bobo', 'b0b0', 'b*b0', 'bobo',
  'engot', 'eng0t', 'eng*t', '3ngot',
  'tonto', 't0nto', 't*nto', 'tont0',
  'tarantado', 'tarant4do', 'tarant*do', 'tarantado',
  'amp', '4mp', '*mp', 'ampot',
  'ampota', '4mpota', '*mpota', 'amp*t4',
  'amputa', '4mputa', '*mputa', 'amp*t4',
  'anak', 'anakng', 'anakngputa', 'anakngtang',
  'inamo', 'in4mo', 'in*mo', 'in4m0',
  'namo', 'n4mo', 'n*mo', 'nam0',
  'pakyu', 'p4kyu', 'p*kyu', 'paky*u',
  'kantot', 'kant0t', 'k*nt0t', 'k4ntot',
  'kantutan', 'kantut4n', 'k*ntut4n', 'k4ntut4n',
  'burat', 'bur4t', 'b*r4t', 'burat',
  'bayag', 'b4yag', 'b*y4g', 'bayag',
  'titi', 't1t1', 't*t1', 'tit1',
  'pepe', 'p3p3', 'p*p3', 'pep3',
  'kiki', 'k1k1', 'k*k1', 'kik1',
  'kingina', 'kingin4', 'kingin*', 'k1ngin4',
  'kainmo', 'k4inmo', 'k*inmo', 'k41nm0',
  'ipapakainmo', '1papakainmo', '1papak41nm0',
  'putragis', 'putr4g1s', 'putr*g1s', 'putrag1s',
  'syet', 'sy3t', 's*y3t', 'shyet',
  'shet', 'sh3t', 'sh*t', 'sh3t',
  'shit', 'sh1t', 'sh*t', 'sh3t',
  'fuck', 'f*ck', 'fuk', 'f4ck',
  'bitch', 'b1tch', 'b*tch', 'b1tch',
  'ass', '*ss', 'a$$', '4ss',
  'damn', 'd*mn', 'd4mn', 'd*m',
  'hell', 'h3ll', 'h*ll', 'he11',
  'puta', 'put4', 'p*ta', 'put@',
  'gago', 'g4go', 'g*go', 'g@g0',
  'tanga', 't4nga', 't*nga', 'tang@',
  'buang', 'bu4ng', 'b*ang', 'bw4ng',
  'ulol', 'ul0l', 'u1ol', 'u101',
  'bobo', 'b0b0', 'b*b0', 'b0b0',
  'engot', '3ngot', 'eng0t', '3ng0t',
  'tonto', 't0nto', 't*nto', 't0nt0',
  'tarantado', 'tarant4do', 'tarant*do', 'tarantado',
  'punyeta', 'puny3ta', 'puny*t4', 'punyet4',
  'leche', 'l3che', 'l*che', 'lech3',
  'pakshet', 'paksh3t', 'paksh*t', 'paksheet',
  'lintik', 'l1ntik', 'l*ntik', 'lint1k',
  'yawa', 'yaw4', 'y*w4', 'yawa',
  'hinayupak', 'hin4yupak', 'hinayup4k', 'hin4yup4k',
];

// Bisaya profanity list (common curses and vulgar terms)
const BISAYA_PROFANITY = [
  'puta', 'putang', 'putangina', 'putanginamo', 'putanginang',
  'tangina', 'tanginamo', 'tanginang', 'tanginae',
  'gago', 'gaga', 'gag0', 'g@g0', 'gagu',
  'pota', 'potang', 'potangina', 'potanginamo',
  'tanga', 'tangang', 'tangae', 't4nga',
  'buang', 'bwang', 'bvuang', 'bu4ng',
  'kupal', 'kup4l', 'kupal', 'k*p4l',
  'tite', 'titi', 't1te', 't*t1', 'tit3',
  'puki', 'puk1', 'p*k1', 'puking',
  'lintik', 'l1ntik', 'l*ntik', 'lint1k',
  'yawa', 'yaw4', 'y*w4', 'yawa',
  'pakshet', 'paksh*t', 'paksh3t', 'paksheet',
  'leche', 'l3che', 'l*che', 'lech3',
  'punyeta', 'puny3ta', 'puny*t4', 'punyet4',
  'hinayupak', 'hin4yupak', 'hinayup4k', 'hin4yup4k',
  'ulol', 'ul0l', 'u1ol', 'u101',
  'bobo', 'b0b0', 'b*b0', 'bobo',
  'engot', 'eng0t', 'eng*t', '3ngot',
  'tonto', 't0nto', 't*nto', 'tont0',
  'tarantado', 'tarant4do', 'tarant*do', 'tarantado',
  'amp', '4mp', '*mp', 'ampot',
  'ampota', '4mpota', '*mpota', 'amp*t4',
  'amputa', '4mputa', '*mputa', 'amp*t4',
  'anak', 'anakng', 'anakngputa', 'anakngtang',
  'inamo', 'in4mo', 'in*mo', 'in4m0',
  'namo', 'n4mo', 'n*mo', 'nam0',
  'pakyu', 'p4kyu', 'p*kyu', 'paky*u',
  'kantot', 'kant0t', 'k*nt0t', 'k4ntot',
  'kantutan', 'kantut4n', 'k*ntut4n', 'k4ntut4n',
  'burat', 'bur4t', 'b*r4t', 'burat',
  'bayag', 'b4yag', 'b*y4g', 'bayag',
  'titi', 't1t1', 't*t1', 'tit1',
  'pepe', 'p3p3', 'p*p3', 'pep3',
  'kiki', 'k1k1', 'k*k1', 'kik1',
  'kingina', 'kingin4', 'kingin*', 'k1ngin4',
  'kainmo', 'k4inmo', 'k*inmo', 'k41nm0',
  'ipapakainmo', '1papakainmo', '1papak41nm0',
  'putragis', 'putr4g1s', 'putr*g1s', 'putrag1s',
  'syet', 'sy3t', 's*y3t', 'shyet',
  'shet', 'sh3t', 'sh*t', 'sh3t',
  'shit', 'sh1t', 'sh*t', 'sh3t',
  'fuck', 'f*ck', 'fuk', 'f4ck',
  'bitch', 'b1tch', 'b*tch', 'b1tch',
  'ass', '*ss', 'a$$', '4ss',
  'damn', 'd*mn', 'd4mn', 'd*m',
  'hell', 'h3ll', 'h*ll', 'he11',
  'puta', 'put4', 'p*ta', 'put@',
  'gago', 'g4go', 'g*go', 'g@g0',
  'tanga', 't4nga', 't*nga', 'tang@',
  'buang', 'bu4ng', 'b*ang', 'bw4ng',
  'ulol', 'ul0l', 'u1ol', 'u101',
  'bobo', 'b0b0', 'b*b0', 'b0b0',
  'engot', '3ngot', 'eng0t', '3ng0t',
  'tonto', 't0nto', 't*nto', 't0nt0',
  'tarantado', 'tarant4do', 'tarant*do', 'tarantado',
  'punyeta', 'puny3ta', 'puny*t4', 'punyet4',
  'leche', 'l3che', 'l*che', 'lech3',
  'pakshet', 'paksh3t', 'paksh*t', 'paksheet',
  'lintik', 'l1ntik', 'l*ntik', 'lint1k',
  'yawa', 'yaw4', 'y*w4', 'yawa',
  'hinayupak', 'hin4yupak', 'hinayup4k', 'hin4yup4k',
  'kagwang', 'k4gw4ng', 'k*gw4ng', 'kagwang',
  'pisteng', 'p1st3ng', 'p*st3ng', 'pisteng',
  'pisti', 'p1st1', 'p*st1', 'pisti',
  'yawa', 'yaw4', 'y*w4', 'yawa',
  'lintik', 'l1ntik', 'l*ntik', 'lint1k',
  'buang', 'bu4ng', 'b*ang', 'bw4ng',
  'bogo', 'b0g0', 'b*g0', 'bogo',
  'unsa', 'un5a', 'un*a', 'unsa',
  'kawatan', 'k4w4t4n', 'k*w4t4n', 'kawatan',
  'pangit', 'p4ng1t', 'p*ng1t', 'pangit',
  'bug-at', 'bug4t', 'b*g4t', 'bugat',
  'hilaw', 'h1l4w', 'h*l4w', 'hilaw',
  'sira', 's1r4', 's*r4', 'sira',
  'ulaw', 'ul4w', 'u1aw', 'ulaw',
  'kuyaw', 'kuy4w', 'k*y4w', 'kuyaw',
  'gahi', 'g4h1', 'g*h1', 'gahi',
  'pangit', 'p4ng1t', 'p*ng1t', 'pangit',
  'pangitaw', 'p4ng1t4w', 'p*ng1t4w', 'pangitaw',
  'buang', 'bu4ng', 'b*ang', 'bw4ng',
  'kagwang', 'k4gw4ng', 'k*gw4ng', 'kagwang',
  'pisteng', 'p1st3ng', 'p*st3ng', 'pisteng',
  'pisti', 'p1st1', 'p*st1', 'pisti',
  'yawa', 'yaw4', 'y*w4', 'yawa',
  'lintik', 'l1ntik', 'l*ntik', 'lint1k',
  'buang', 'bu4ng', 'b*ang', 'bw4ng',
  'bogo', 'b0g0', 'b*g0', 'bogo',
  'unsa', 'un5a', 'un*a', 'unsa',
  'kawatan', 'k4w4t4n', 'k*w4t4n', 'kawatan',
  'pangit', 'p4ng1t', 'p*ng1t', 'pangit',
  'bug-at', 'bug4t', 'b*g4t', 'bugat',
  'hilaw', 'h1l4w', 'h*l4w', 'hilaw',
  'sira', 's1r4', 's*r4', 'sira',
  'ulaw', 'ul4w', 'u1aw', 'ulaw',
  'kuyaw', 'kuy4w', 'k*y4w', 'kuyaw',
  'gahi', 'g4h1', 'g*h1', 'gahi',
  'pangit', 'p4ng1t', 'p*ng1t', 'pangit',
  'pangitaw', 'p4ng1t4w', 'p*ng1t4w', 'pangitaw',
];

// Character substitution map for normalization
const SUBSTITUTIONS = {
  '@': 'a',
  '4': 'a',
  '3': 'e',
  '1': 'i',
  '0': 'o',
  '$': 's',
  '5': 's',
  '7': 't',
  '9': 'g',
  '!': 'i',
  '*': '',
  '#': '',
  '-': '',
  '_': '',
};

/**
 * Normalize a message for profanity detection
 * - Convert to lowercase
 * - Remove extra spaces
 * - Handle character substitutions
 * - Handle repeated characters
 */
function normalizeMessage(message) {
  if (!message || typeof message !== 'string') {
    return '';
  }

  let normalized = message.toLowerCase();

  // Replace character substitutions
  Object.keys(SUBSTITUTIONS).forEach(char => {
    normalized = normalized.split(char).join(SUBSTITUTIONS[char]);
  });

  // Remove extra spaces
  normalized = normalized.replace(/\s+/g, ' ').trim();

  // Reduce repeated characters (e.g., "fuuuck" -> "fuck")
  normalized = normalized.replace(/([a-z])\1{2,}/g, '$1$1');

  return normalized;
}

/**
 * Check if a message contains profanity
 * @param {string} message - The message to check
 * @returns {object} - Object with containsProfanity boolean and detected words array
 */
function containsProfanity(message) {
  if (!message || typeof message !== 'string') {
    return { containsProfanity: false, detectedWords: [] };
  }

  const normalized = normalizeMessage(message);
  const words = normalized.split(/\s+/);
  const detectedWords = [];

  // Check each word against profanity lists
  words.forEach(word => {
    // Check English profanity
    ENGLISH_PROFANITY.forEach(profanity => {
      if (word === profanity) {
        if (!detectedWords.includes(profanity)) {
          detectedWords.push(profanity);
        }
      } else if (word.includes(profanity) && profanity.length >= 5) {
        // Substring matching for profanities 5+ chars only
        // This catches combined profanities like "fuckassbitch" but avoids false positives like "hello" for "hell"
        if (!detectedWords.includes(profanity)) {
          detectedWords.push(profanity);
        }
      }
    });

    // Check Tagalog profanity
    TAGALOG_PROFANITY.forEach(profanity => {
      if (word === profanity) {
        if (!detectedWords.includes(profanity)) {
          detectedWords.push(profanity);
        }
      } else if (word.includes(profanity) && profanity.length >= 5) {
        if (!detectedWords.includes(profanity)) {
          detectedWords.push(profanity);
        }
      }
    });

    // Check Bisaya profanity
    BISAYA_PROFANITY.forEach(profanity => {
      if (word === profanity) {
        if (!detectedWords.includes(profanity)) {
          detectedWords.push(profanity);
        }
      } else if (word.includes(profanity) && profanity.length >= 5) {
        if (!detectedWords.includes(profanity)) {
          detectedWords.push(profanity);
        }
      }
    });
  });

  return {
    containsProfanity: detectedWords.length > 0,
    detectedWords
  };
}

/**
 * Validate a message and return error message if profanity is detected
 * @param {string} message - The message to validate
 * @returns {object} - Object with isValid boolean and errorMessage string
 */
function validateMessage(message) {
  const result = containsProfanity(message);

  if (result.containsProfanity) {
    return {
      isValid: false,
      errorMessage: 'Please remove inappropriate language from your message before sending.'
    };
  }

  return {
    isValid: true,
    errorMessage: null
  };
}

export { containsProfanity, validateMessage, normalizeMessage };
